"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxActionsByType = exports.MaxWsTopics = exports.OrgExpiringPageMaxDuration = void 0;
const time_ms_1 = require("./time-ms");
// export const WsRelayPayloadMaxChars = 1024 * 1024; // placeholder. todo: enforce using nginx, gateway, etc.
exports.OrgExpiringPageMaxDuration = time_ms_1.DayMs * 8;
exports.MaxWsTopics = 32;
exports.MaxActionsByType = 32;
//# sourceMappingURL=task-runner-ws-relay.js.map